import type {Raid} from "@/raids/rest/RaidSchema.ts";
import {Card, Carousel, Typography} from "antd";
import {useNavigate} from "@tanstack/react-router";
import {Pending} from "@/components/Pending.tsx";
import {RaidInfoCard} from "@/home/RaidInfoCard.tsx";

type Props = {
  runningRaids?: Raid[],
  isLoading: boolean,
}

export function RaidRunning({runningRaids = [], isLoading}: Props) {

  const navigate = useNavigate();

  function joinRaid(id: number): void {
    void navigate({
      to: "/raids/$raidId",
      params: { raidId: String(id) },
    });
  }

  return (
      <Card
          title={
            <Typography.Title level={4}>Laufende Raids</Typography.Title>
          }
          className={"shadow-black"}
      >
        {isLoading ? (
            <Pending/>
        ) : (
            <Carousel autoplay={{dotDuration: true}} autoplaySpeed={4000}>
              {
                runningRaids.map(raid => {
                  return <div className={"p-4"} key={raid.id}>
                    <div className={"flex justify-center"}>
                      <RaidInfoCard raid={raid} joinRaid={joinRaid}/>
                    </div>
                  </div>
                })
              }
            </Carousel>
        )}
      </Card>
  )
}